module.exports = __webpack_public_path__ + "img/bar-chart.c4da60fd.svg";